import {successSaveInfo} from '../reducers/todo-reducer';
import * as firebase from 'firebase';
import {properties} from '../properties/properties';
import $ from 'jquery';

export default  {

	saveInfo(values){
		
		return new Promise((resolve,reject)=>{
      
            try{

                 var d = new Date();
                var month = d.getMonth()+1;
                var day = d.getDate();
                var year = d.getFullYear();
                
                if(month < 10){
                    month = "0"+month;
                }
                
                if(day < 10){
                    day = "0"+day;
                }
                values.timeStamp = d.getTime();
                values.fechaCreacion = day + "/"+month+"/"+year;
                const database = firebase.database();
                const key = database.ref('auto_elite').push().key;
                const newInfo = database.ref('auto_elite/'+key);
                newInfo.set(values,(err)=>{
                    
                    if(err == null){
                         values.error = false;

                        var message="<h3>Auto Elite</h3><p><label>Nombre: "+values.nombre+" "+values.apellidos +"</label>"+
                        "<br/><label>Correo: "+values.correo+" </label>"+
                        "<br/><label>Teléfono: "+values.telefono+" </label>"+
                        "<br/><label>Tipo Teléfono: "+values.tipoTelefono+"</label>"+
                        "<br/><label>Fecha: "+values.fechaCreacion+"</label></p>";

                        var bodyRequest ={
                            	from: properties().CORREOS_FROM,
                                to:properties().CORREOS_TO,
                                subject:"Registro Auto Elite",
                                typeBody:"html",
                                message:message

                        };



                        $.ajax({
                                url: properties().CORREO_ENDPOINT, 
                                type: "POST",
                                data:  bodyRequest, 
                                dataType: 'json', 
                                success: function(data,status,req){
                                   
                                        resolve({exito:true,texto:"Muchas Gracias, tus datos han sido recibidos, en breve un Asesor se pondrá en contacto contigo."})
                     
                                }, 
                                error: function(data,status,req){
                                    resolve({exito:false,texto:"Sucedió un error al guardar la información."});
                                }
                            });

                      
                    }else{
                        
                        resolve({exito:false,texto:"Ocurrió un error al guardar la información."});
                      
                    }
                });
            }catch(err){
                 
                resolve({exito:false,texto:"Ocurrió un error al guardar la información"});
            }

		}).then(successSaveInfo);
	}

}



// WEBPACK FOOTER //
// ./src/apis/todo-api.js